
YP.FormAdvanced = function() {

    return {
        init: function() {
            var eventForms     = $("#eventForms");
            var inputLastName  = $('input[nature="1"]').first();
            var inputFirstName = $('input[nature="2"]').first();
            var inputEmail     = $('input[nature="6"]').first();

            if(eventForms.length > 0){
                var questionInError = $(".question_error", eventForms);
                if(questionInError.length > 0){
                     $('html, body').animate({
                        scrollTop: questionInError.first().offset().top - 40
                    }, 'slow');
                }
            }

            if(inputLastName.length) {
                $('#ticketRegister_last_name').on('change keyup', function(e){
                    inputLastName.val($(this).val());
                });
            }
            if(inputFirstName.length) {
                $('#ticketRegister_first_name').on('change keyup', function(e){
                    inputFirstName.val($(this).val());

                });
            }
            if(inputEmail.length) {
                $('#ticketRegister_email_address').on('change keyup', function(e){
                    inputEmail.val($(this).val());
                });
            }
        }
    };

};

window.addEventListener("load", function(){
    YP.FormAdvanced().init();
});
